/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState, useEffect, useCallback } from 'react';
// import IO from 'socket.io-client';
import { format } from 'date-fns';

import { Container, Table } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { useToast } from '../../hooks/toast';

// import DadosNota from '../../components/DadosNota';
import ItemTabela from '../../components/ItemTabela';
// import Modal from '../../components/Modal';
import { TIPO_USUARIO } from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';
import { useNotaFiscal } from '../../hooks/notafiscal';
import { useFormaPagamento } from '../../hooks/formapagamento';

export interface INotafiscal {
  CprCodigo: number;
  CprDataPag: string;
  FormaPagto: string;
  NfeCodigoVerificacao?: string;
  NfeCprCodigo?: number;
  NfeLinkNFSe?: string;
  NfeNumero: string;
  NfeSituacao: string;
  NumeroNF?: string;
  NfeNumeroNFSe?: string;
  descricao: string;
  nome: string;
  vlr: number;
  vlrFormatado: string;
  linkNota?: string;
  NfeId?: string;
  NfeMessage?: string;
}

// const socket = io(document.getElementById('HidUrlAPI').value);
// const socket = IO('http://localhost:3333/', { query: { usu: 1 } });
const Nota: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();
  const { optionsFormasPagamento, buscaFormaPagamento } = useFormaPagamento();
  const { loading, notasFiscais, buscaNotas } = useNotaFiscal();
  // const [loading, setLoading] = useState(false);
  // const [notasFiscais, setNotasFiscais] = useState<INotafiscal[]>([]);
  const [botaoClicado, setBotaoClicado] = useState('');
  // const [cprCodigo, setCprCodigo] = useState('');
  const [txtData, setTxtData] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [cboTipo, setCboTipo] = useState('Todos');
  const [cboFormaPagto, setCboFormaPagto] = useState('');

  // const [showModal, setShowModal] = useState(false);

  const { addToast } = useToast();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  useEffect(() => {
    async function loadFormaPagto(): Promise<void> {
      await buscaFormaPagamento();
    }
    if (
      !optionsFormasPagamento.optionFormaPagamento ||
      Object.keys(optionsFormasPagamento.optionFormaPagamento).length === 0
    )
      loadFormaPagto();
  }, [buscaFormaPagamento, optionsFormasPagamento]);

  const BuscaNota = useCallback(
    async (botao: string): Promise<void> => {
      const textoBotao = document.getElementById(botao)?.textContent;
      let requisicao = 'rps/selectNotaFiscalPendente';

      if (textoBotao) {
        setBotaoClicado(botao);

        if (textoBotao.trim() === 'Buscar') {
          // const teste: HTMLInputElement = document.getElementById('HidClinica');
          const teste = '1';
          if (!teste) {
            addToast({
              type: 'error',
              title: 'Digite uma data.',
            });

            return;
          }
          let tipo = '';
          if (cboTipo !== 'Todos') tipo = `&tipo=${cboTipo}`;
          const formaPagto = `&pagto=${cboFormaPagto}`;

          requisicao = `rps/selectNotaFiscal/?dataFilter=${txtData}${tipo}${formaPagto}`;
        }
      }
      buscaNotas(requisicao);
    },
    [addToast, cboFormaPagto, cboTipo, txtData, buscaNotas],
  );

  return (
    <>
      <Container fluid className="mt-2">
        <header className="py-2">
          <h4 className="text-secondary pl-4"> Notas Fiscais </h4>
        </header>
        <br className="clearfix" />
        <div className="bg-white p-3 border rounded">
          <p className="text-secondary mb-0">
            Emita, e consulte Notas Fiscais de Serviço
          </p>
          <br className="clearfix" />
          <form id="notaForm">
            <div className="row small">
              <div className="col-md-3 form-group">
                <label className="mr-1" htmlFor="TxtData">
                  <b> Data </b>
                </label>
                <input
                  name="TxtData"
                  id="TxtData"
                  type="date"
                  className="form-control form-control-sm"
                  onChange={e => setTxtData(e.target.value)}
                  value={txtData}
                />
              </div>
              <div className="col-md-3 form-group">
                <label htmlFor="CboTipo">
                  <b> Tipo </b>
                </label>
                <select
                  name="CboTipo"
                  id="CboTipo"
                  className="form-control form-control-sm"
                  onChange={e => setCboTipo(e.target.value)}
                  value={cboTipo}
                >
                  <option value="Todos"> Todos </option>
                  <option value="2">Consulta Médica</option>
                  <option value="1"> Exames </option>
                  <option value="3">Procedimento Odontológico</option>
                  <option value="4">Cartão Saúde</option>
                </select>
              </div>
              <div className="col-md-2 form-group">
                <label htmlFor="CboFormaPagto">
                  <b> Forma Pagto. </b>
                </label>
                <select
                  name="CboFormaPagto"
                  id="CboFormaPagto"
                  className="form-control form-control-sm"
                  onChange={e => setCboFormaPagto(e.target.value)}
                  value={cboFormaPagto}
                >
                  <option value=""> Todos </option>
                  {optionsFormasPagamento.optionFormaPagamento &&
                    optionsFormasPagamento.optionFormaPagamento
                      .filter(forma => !forma.isDisabled)
                      .map(forma => (
                        <option value={forma.label}> {forma.label} </option>
                      ))}
                </select>
              </div>
              <div className="col-md-2">
                <br />
                <button
                  type="button"
                  name="CmdBuscar"
                  id="CmdBuscar"
                  className="btn btn-sm btn-primary mt-md-2"
                  onClick={() => BuscaNota('CmdBuscar')}
                  disabled={loading}
                >
                  {loading && botaoClicado === 'CmdBuscar'
                    ? 'Carregando'
                    : 'Buscar'}
                </button>
              </div>
              <div className="col-md-2">
                <br />
                <button
                  type="button"
                  name="CmdBuscarPendentes"
                  id="CmdBuscarPendentes"
                  className="btn btn-sm btn-danger mt-md-2"
                  onClick={() => BuscaNota('CmdBuscarPendentes')}
                  disabled={loading}
                >
                  {loading && botaoClicado === 'CmdBuscarPendentes'
                    ? 'Carregando'
                    : 'Buscar Pendentes'}
                </button>
              </div>
            </div>
          </form>
          <span id="LblRespGrid" />
          <div>
            <form id="formTable">
              <Table striped bordered hover size="sm" id="GrdConsulta">
                <tbody>
                  <tr className="bg-light">
                    <th> Nome </th> <th> Serviço </th> <th> Valor </th>
                    <th> Data Pagto </th> <th> Forma Pagto </th>
                    <th> Situação </th> <th> RPS </th>
                    <th> Nota Fiscal </th> <th> </th>
                  </tr>
                  {notasFiscais.map(nota => {
                    return (
                      <ItemTabela
                        key={`it-${nota.CprCodigo}-${nota.NfeId}`}
                        Item={nota}
                      />
                    );
                  })}
                </tbody>
              </Table>
            </form>
          </div>
        </div>
        {/* <div>
          {showModal && (
            <Modal
              show={showModal}
              titulo=" Dados da Nota Fiscal"
              handleFecharModal={() => setShowModal(false)}
            >
              <div>
                <DadosNota
                  codigo={String(cprCodigo)}
                  handleFecharModal={() => setShowModal(false)}
                />
              </div>
            </Modal>
          )}
        </div> */}
      </Container>
    </>
  );
};

export default Nota;
